import axios from "axios";
import { Message } from "element-ui";
import store from "../store";
import {
  getToken,
  getModel,
  syncGetToken,
  setToken,
  getRootDomain
} from "./auth";

// var user = new Mgr()
// 是否正在刷新的标记
let isRefreshing = false;
// 重试队列，每一项将是一个待执行的函数形式
const requests = [];

// 创建axios实例
const service = axios.create({
  baseURL: window.SERVERAPI.API_USER || "/"
});

/**
 * 提取文件名.
 * @param response axios的response
 * @description 从reponse header的content-disposition中提取文件名.
 */
const extractFilenameFromResponseHeader = (response) => {
  // content-disposition: "attachment; filename=xxxx.docx;"
  const contentDisposition = response.headers["content-disposition"];
  const patt = new RegExp("filename=([^;]+\\.[^\\.;]+);*");
  const result = patt.exec(contentDisposition);
  let filename = "";

  if (result) {
    filename = result.length > 0 ? result[1] : "";
  }
  // 解码之前尝试去除空格和双引号
  // content-disposition: "attachment; filename=\"xxxx.docx\";"
  return decodeURIComponent(filename.trim().replace(new RegExp('"', "g"), ""));
};

// const whiteList = ['/login', '/auth-redirect'] // no redirect whitelist
// request拦截器
service.interceptors.request.use(async (config) => {
  // Do something before request is sent
  // console.log(setToken())

  config.headers["Access-Control-Allow-Origin"] = "*";
  let { model } = await getModel();

  if (!model) {
    let token = await syncGetToken().then(
      (acessToken) => {
        let { token } = acessToken;
        setToken(token)
        return token;
      },
      (err) => {
        // console.log(err)
        return "";
      }
    );
    config.headers["Authorization"] = "Bearer " + token;
    return config;
  }

  let token = getToken();
  // let token = getToken()
  if (token) {
    config.headers["Authorization"] = "Bearer " + token; // 让每个请求携带token--['X-Token']为自定义key 请根据实际情况自行修改
    return config;
  } else {
    if (config.url.indexOf("/oauth2/token") > 0 || !getToken("FN_REFTOKEN")) {
      return config;
    }
    if (isRefreshing) {
      return new Promise((resolve) => {
        requests.push((token) => {
          config.headers["Authorization"] = "Bearer " + token;
          resolve(config);
        });
      });
    }
    isRefreshing = true;
    return store
      .dispatch("RefreshToken")
      .then((token) => {
        requests.forEach((cb) => cb(token));
        config.headers["Authorization"] = "Bearer " + token;
        return config;
      })
      .catch((res) => {
        console.error("refreshtoken error =>", res);
        // window.location.href = '/'
      })
      .finally(() => {
        isRefreshing = false;
      });
  }
});

// respone拦截器
service.interceptors.response.use(
  (res) => {
    if (store.state.loading) {
      setTimeout(function () {
        store.commit("LOADING", false);
      }, 500);
    }

    if (
      res.error === "invalid_grant" ||
      (res.data.code &&
        (res.data.code === 100 ||
          res.data.code === 104 ||
          res.data.code === 105))
    ) {
      store.dispatch("goLogin");
      return Promise.reject(res);
    }
    // console.log(
    //   ["blob", "arraybuffer"].indexOf(res.config.responseType),
    //   res.config.responseType
    // );
    if (
      ["blob", "arraybuffer"].indexOf(res.config.responseType) >= 0 &&
      res.data.succeed === undefined
    ) {
      return res.data;
    }
    if (res.data.code === 123 && res.data.msg) {
      return Promise.reject(res.data);
    }
    if (!res.data.succeed) {
      // if (res.data.msg === '数据不存在') return res.data
      if (res.data.msg && res.data.msg !== "数据不存在") {
        Message({
          message: res.data.msg,
          type: "warning",
          duration: 2000
        });
      }

      return Promise.reject(res.data);
    }
    return res.data;
  },
  (error) => {
    console.log("err" + error); // for debug

    Message({
      message:
        (error && error.data && error.data.msg) ||
        "网络错误或获取失败，请刷新后重试", // error.message,
      type: "error",
      duration: 5 * 1000
    });
    return Promise.reject(error);
  }
);

export default service;
